import React from "react"

export default () => <svg viewBox="0 0 12 8" width="12px" height="8px"><path d="M1.757 2L6 6.243 10.243 2" stroke="#111" strokeWidth="2" fill="none"></path></svg>